import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function pervalLoginValidator(): ValidatorFn {
  // Expression régulière qui n'autorise que les lettres minuscules, chiffres, point, tiret et underscore, sans espaces.
  const regex = /^(?!.*\s)[a-z0-9.\-_]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    // Si le champ est vide, on ne valide pas (peut être géré par le validateur "required")
    if (!control.value) {
      return null;
    }

    const valid = regex.test(control.value);
    return valid ? null : { invalidLogin: true };
  };
}
